import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { message } from 'antd';
import { SocialContext } from '../../contexts/socialContext';
import { PAGINATE_DEFAULT, StateContext } from '../../contexts/stateContext';
import { Button } from '../UiKit/Button';
import { AdminMenu } from './AdminMenu';

const BOOL_FLAGS = [
  { key: 'png', label: 'PNG bodygraphs', setter: 'setPng' },
  { key: 'mode3d', label: '3D bodygraph', setter: 'setMode3d' },
  { key: 'narrativeBeta', label: 'Narrative beta', setter: 'setNarrativeBeta' },
  { key: 'jyotishShown', label: 'Jyotish', setter: 'setJyotishShown' },
  { key: 'pentaFolders', label: 'Penta folders', setter: 'setPentaFolders' },
  { key: 'groupsShown', label: 'Groups', setter: 'setGroupsShown' },
  { key: 'supportShown', label: 'Support', setter: 'setSupportShown' },
];

const VARNA_OPTIONS = [
  { value: 'nakshatra', label: 'Nakshatra' },
  { value: 'moonSign', label: 'Moon sign' },
];

const FlagRow = ({ label, name, active, onClick, children }) => (
  <div
    className={`x_settings_action ${active ? 'active' : ''}`}
    onClick={onClick}
    style={{
      cursor: 'pointer',
      background: '#fff',
      borderRadius: '0.6em',
      padding: '0.9em 1em',
    }}
  >
    <div>
      <div className="x_choose_filter_title">{label}</div>
      <div style={{ opacity: 0.45, fontSize: '0.85em', marginTop: '0.15em' }}>{name}</div>
    </div>
    <div className="x_settings_right">
      {children}
    </div>
  </div>
);

export function AdminFlags() {
  const context = useContext(StateContext);
  const social = useContext(SocialContext);
  const { state, setState } = context;

  const handleCreateGroup = () => {
    social.x.createGroup({
      name: 'New group',
      description: '',
    }, (newGroup, error) => {
      if (!newGroup) {
        message.error(error?.message || 'Failed to create group');
        return;
      }
      const label = newGroup.name || 'New group';
      const token = newGroup.token ? ` (${newGroup.token})` : '';
      message.success(`Group created: ${label}${token}`);
    });
  };

  return (
    <>
      <div
        className="b b--admin"
      >
        <AdminMenu active="flags" />
        
        <div className="admin_content _fv _fgap2" style={{ maxWidth: '36em' }}>
          <h1>🚩 Flags</h1>
          <div style={{ opacity: 0.5 }}>Local client flags. Stored in this browser.</div>

          <div className="_fv _fgap1">
            {BOOL_FLAGS.map(({ key, label, setter }) => {
              const on = Boolean(state[key]);
              return (
                <FlagRow
                  key={key}
                  label={label}
                  name={key}
                  active={on}
                  onClick={() => setState[setter]((prev) => !prev)}
                >
                  <div className={`x_settings_check ${on ? 'active' : ''}`}>
                    <div className="t_icon t_icon--20">
                      {on ? 'toggle_on' : 'toggle_off'}
                    </div>
                  </div>
                </FlagRow>
              );
            })}

            <FlagRow label="Paginate" name="paginate" active={false}>
              <div onClick={(event) => event.stopPropagation()}>
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  autoComplete="off"
                  value={state.paginate ?? ''}
                  onChange={(event) => {
                    const digits = event.target.value.replace(/\D/g, '');
                    setState.setPaginate(digits === '' ? '' : Number(digits));
                  }}
                  onBlur={() => {
                    if (!Number(state.paginate)) setState.setPaginate(PAGINATE_DEFAULT);
                  }}
                  style={{
                    width: '4.5em',
                    padding: '0.35em 0.6em',
                    borderRadius: '0.5em',
                    border: '1px solid #ccc',
                    font: 'inherit',
                    textAlign: 'center',
                  }}
                />
              </div>
            </FlagRow>

            <FlagRow label="Varna by" name="varnaBy" active={false}>
              <div className="_f _fgap1" onClick={(event) => event.stopPropagation()}>
                {VARNA_OPTIONS.map(({ value, label }) => (
                  <button
                    key={value}
                    type="button"
                    onClick={() => setState.setVarnaBy(value)}
                    style={{
                      padding: '0.35em 0.8em',
                      borderRadius: '0.5em',
                      border: state.varnaBy === value ? '1px solid #1900ff' : '1px solid #ccc',
                      background: state.varnaBy === value ? '#1900ff' : '#fff',
                      color: state.varnaBy === value ? '#fff' : 'inherit',
                      font: 'inherit',
                      cursor: 'pointer',
                    }}
                  >
                    {label}
                  </button>
                ))}
              </div>
            </FlagRow>
          </div>
          <hr/>
          <Link to="/body3d">Show body3d</Link>
          <hr/>
          <Button onClick={handleCreateGroup}>Create group</Button>
        </div>
      </div>
    </>
  );
}

export default AdminFlags;
